import { render, staticRenderFns } from "./aRoomDetailHisOwner.vue?vue&type=template&id=2a5862b6&scoped=true"
import script from "./aRoomDetailHisOwner.vue?vue&type=script&lang=js"
export * from "./aRoomDetailHisOwner.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailHisOwner.vue?vue&type=style&index=0&id=2a5862b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5862b6",
  null
  
)

export default component.exports